import { ResearchProjectResult } from "interface/research"
import {
  Stack, Box, Alert,
  List, ListItem, ListItemProps, ListItemButton, 
  Typography
} from "@mui/material"
import { ResearchReportTypeChip } from "features/research/components/reportTypeChip"
import { useMemo } from "react"
import { ResearchWordsChips } from "features/research/components/wordsChips"

type ResearchListRecordProps = {
  project: ResearchProjectResult
  onSelChangeProject: (project: ResearchProjectResult) => void
} & ListItemProps
export const ResearchListRecord = ({
  project,
  onSelChangeProject,
  ...others
}: ResearchListRecordProps) => {
  const lastest = useMemo(() => project.researchs.at(0), [project])
  return (
    <ListItem disablePadding {...others}>
      <ListItemButton
        onClick={() => onSelChangeProject(project)}
        sx={{
          padding: 1,
          borderBottom: 1,
          borderColor: 'divider'
        }}
      >
        <Stack
          direction='row'
          justifyContent="space-between"
          flexWrap="wrap"
          spacing={0.5}
          useFlexGap
          width='100%'
        >
          <Typography variant='body1' color='text.primary' component='div'>{project.projectName}</Typography>

          {lastest && (
            <Stack
              direction='row'
              flexGrow={1}
              spacing={0.5}
              alignItems='center'
              flexWrap='wrap'
              useFlexGap
            >
              <ResearchReportTypeChip reportType={lastest.reportType} size="small"/>
              <ResearchWordsChips words={lastest.words} size="small"/>
            </Stack>
          )}

          {project.startNendo !== project.endNendo ? (
            <Stack direction='row' spacing={0.5} alignItems='baseline' flexWrap="wrap">
              <Typography variant='body2' component='span'>{project.startNendo}</Typography>
              <Typography variant='caption' component='span'>～</Typography>
              <Typography variant='body2' component='span'>{project.endNendo}</Typography>
              <Typography variant='caption' component='span'>年度</Typography>
            </Stack>
          ) : (
            <Stack direction='row' spacing={0.5} alignItems='baseline' flexWrap="wrap">
              <Typography variant='body2' component='span'>{project.startNendo}</Typography>
              <Typography variant='caption' component='span'>年度（単年）</Typography>
            </Stack>
          )}
        </Stack>
      </ListItemButton>
    </ListItem>
  )
}

type ResearchListProps = {
  projects: ResearchProjectResult[]
  onSelChangeProject: (projectKey: string) => void
}
export const ResearchList = ({
  projects,
  onSelChangeProject: onSelChangeProject
}: ResearchListProps) => {
  return projects.length === 0 ? (
    <Box padding={1}><Alert severity="info">対象が見つかりません.</Alert></Box>
  ) : (
    <List disablePadding>
      {projects.map(record =>
        <ResearchListRecord
          key={record.projectKey}
          project={record}
          onSelChangeProject={project => onSelChangeProject(project.projectKey)} />
      ) }
    </List>
  )
}

